import { COLOR_SETTINGS_PARENT_FOLDER } from 'services/networking/swipe';
import { B2bUserType } from 'shared-types/user';

const BACKGROUND_COLOR_FILENAME = 'background';
const BACKGROUND_COLOR_FILE_EXTENSION = '.jpg';
export const B2C_BACKGROUND_COLOR_FILENAME = `${BACKGROUND_COLOR_FILENAME}${BACKGROUND_COLOR_FILE_EXTENSION}`;
export const B2B_BACKGROUND_COLOR_FILENAME = `${BACKGROUND_COLOR_FILENAME}-pro${BACKGROUND_COLOR_FILE_EXTENSION}`;
export const BAM_BACKGROUND_COLOR_FILENAME = `${BACKGROUND_COLOR_FILENAME}-bam${BACKGROUND_COLOR_FILE_EXTENSION}`;

export const getBackgroundFileUrl = (
  userType: B2bUserType,
  colorSetting: string,
): string => {
  return [
    process.env.REACT_APP_ASSETS_BASE_URL,
    COLOR_SETTINGS_PARENT_FOLDER,
    colorSetting,
    userType === B2bUserType.BAM ? B2B_BACKGROUND_COLOR_FILENAME : B2C_BACKGROUND_COLOR_FILENAME,
  ].join('/');
};
